import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { passActions } from "../../redux/passSlice"; // Import your pass actions
import { Link } from "react-router-dom"; // For navigation between pages
import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";

const PassList = () => {
  const dispatch = useDispatch();
  const { passes, loading, error } = useSelector((state) => state.passes); // Select passes data from the store

  // Fetch passes when the component mounts
  useEffect(() => {
    dispatch(passActions.getPasses());
  }, [dispatch]);

  if (loading) return <div>Loading passes...</div>; // Show loading state
  if (error) return <div>Error: {error}</div>;

  const handleCheckIn = (id) => {
    try {
      dispatch(passActions.checkInPass(id));
      dispatch(passActions.getPasses()); // Dispatch check-in action
    } catch (error) {
      console.log("Check-in failed", error);
    }
  };

  const handleCheckOut = async (id) => {
    try {
      dispatch(passActions.checkOutPass(id));
      dispatch(passActions.getPasses()); // Dispatch check-out action
    } catch (error) {
      console.log("Check-out failed", error);
    }
  }; // Show error message if there was an error

  return (
    <div className="w-full bg-slate-200 p-6 pb-20 rounded-lg shadow-md">
      <div className="bg-white rounded-lg p-4">
        <div className="mb-4 flex justify-between">
          <h1 className="text-xl font-semibold mb-4">Pass List</h1>
          <Link to="/dashboard/generatepass">
            <Button
              type="default"
              className="bg-green-800 text-white hover:bg-green-600"
              icon={<PlusOutlined />}
            >
              Add Passes
            </Button>
          </Link>
        </div>

        {/* Table to display the passes */}
        <div className="bg-gray-200 p-5 rounded-lg">
          <div className="bg-white p-4 rounded-lg overflow-x-auto">
            <table className="min-w-full">
              <thead>
                <tr className="text-left">
                  <th className="py-2 px-4 border-r border-b border-gray-300">
                    Sn
                  </th>
                  <th className="py-2 px-4 border-r border-b border-gray-300">
                    Guest
                  </th>
                  <th className="py-2 px-4 border-r border-b border-gray-300">
                    Date
                  </th>
                  <th className="py-2 px-4 border-r border-b border-gray-300">
                    Invited By
                  </th>
                  <th className="py-2 px-4 border-r border-b border-gray-300">
                    Check in
                  </th>
                  <th className="py-2 px-4 border-b border-gray-300">
                    check out
                  </th>
                </tr>
              </thead>
              <tbody>
                {passes?.map((pass, index) => (
                  <tr key={pass.id} className="hover:bg-gray-50 border-b">
                    <td className="py-2 px-4 border-r border-gray-300">
                      <Link to={`/dashboard/pass/${pass.id}`}>{index + 1}</Link>
                    </td>
                    <td className="py-2 px-4 border-r border-gray-300">
                      {pass.guest_name}
                    </td>
                    <td className="py-2 px-4 border-r border-gray-300">
                      {new Date(pass.date).toLocaleDateString()}
                    </td>
                    <td className="py-2 px-4 border-gray-300">
                      {pass.invited_by}
                    </td>
                    <td
                      className="border border-black text-center"
                      onClick={() => handleCheckIn(pass.id)}
                    >
                      {pass.checked_in ? (
                        pass.checked_in
                      ) : (
                        <svg
                          width="22"
                          height="20"
                          viewBox="0 0 22 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="mx-auto"
                        >
                          <path
                            d="M20.75 0H1.25C1.05109 0 0.860322 0.0526785 0.71967 0.146447C0.579018 0.240215 0.5 0.367392 0.5 0.5V9H9.5V6L17 10L9.5 14V11H0.5V19.5C0.5 19.6326 0.579018 19.7598 0.71967 19.8536C0.860322 19.9473 1.05109 20 1.25 20H20.75C20.9489 20 21.1397 19.9473 21.2803 19.8536C21.421 19.7598 21.5 19.6326 21.5 19.5V0.5C21.5 0.367392 21.421 0.240215 21.2803 0.146447C21.1397 0.0526785 20.9489 0 20.75 0Z"
                            fill="#50B748"
                          />
                        </svg>
                      )}
                    </td>
                    <td
                      className="border border-black text-center"
                      onClick={() => pass.checked_in && handleCheckOut(pass.id)}
                    >
                      {pass.checked_out ? (
                        pass.checked_out
                      ) : (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="mx-auto"
                        >
                          <path
                            d="M18.4999 0H1.49992C1.1242 0 0.763861 0.105357 0.498184 0.292893C0.232508 0.48043 0.083252 0.734784 0.083252 1V10L7.16658 6V9H15.6666V11H7.16658V14L0.083252 10V19C0.083252 19.2652 0.232508 19.5196 0.498184 19.7071C0.763861 19.8946 1.1242 20 1.49992 20H18.4999C18.8756 20 19.236 19.8946 19.5017 19.7071C19.7673 19.5196 19.9166 19.2652 19.9166 19V1C19.9166 0.734784 19.7673 0.48043 19.5017 0.292893C19.236 0.105357 18.8756 0 18.4999 0Z"
                            fill="#BE4B27"
                          />
                        </svg>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PassList;
